import React from "react";
import "@ant-design/compatible/assets/index.css";
import { Select, Form } from "antd";
const { Option } = Select;

const SelectItem = ({
  formItem,
  dataSource,
  selectChange,
  placeholder,
}) => {
    const valueKey = formItem.name;
    const selectOptions = dataSource?.map((data) => (
        <Option key={data._id}>
         { data[`${valueKey}`] }
        </Option>
      ));
  return (
    <Form.Item
      label={formItem.label}
      name={formItem.name}
      rules={[
        {
          required: true,
          message: formItem.message,
        },
      ]}
    >
      <Select
        showSearch
        allowClear
        placeholder={placeholder}
        onChange={selectChange}
        optionFilterProp="children"
        notFoundContent={null}
      >
        {selectOptions}
      </Select>
    </Form.Item>
  );
};

export default SelectItem;

